import {
  FaBusinessTimeIcon,
  FaCalculatorIcon,
  FaCertificateIcon,
  FaCircleCheckIcon,
  FaCircleQuestionIcon,
  FaFileArrowUpIcon,
  FaHouseChimneyIcon,
  FaHpsIcon,
  FaLockIcon,
  FaMagnifyingGlassLocationIcon,
  FaTableListIcon, //TBD
  FaUsersIcon,
} from "../app/styles/styles";
import { ReferralSearchPayload } from "../models/Referral";
import {
  HeadCell10,
  HeadCell20,
  HeadCell30,
  HeadCell50,
  HeadCell70,
  HeadCell90,
} from "../routes/HomeScreen/style/style";
import { DownloadUrl } from "./AppConfigs";
import { ApplicationRoute } from "./ApplicationUrl";
import { PER_PAGE } from "./FunctionalUtils";
import {
  MasterDisciplineActionDispatchTypes,
  MasterPayerActionDispatchTypes,
} from "./Master";
import {
  CreatePatientActionDispatchTypes,
  EligibilityCheckActionDispatchTypes,
  IcdCodeActionDispatchTypes,
  InformationActionDispatchTypes,
  MemberInfoDataActionDispatchTypes,
  PatientFromMbiActionDispatchTypes,
  PatientInformationByIdActionDispatchTypes,
} from "./Patient";
import {
  IngestProcessActionDispatchTypes,
  PostPriorAuthSubmitActionDispatchTypes,
  PostReAuthRequestDispatchTypes,
  ReferralDocumentFileDispatchTypes,
  SlotsDispatchTypes,
} from "./Referral";
import { TabSessionStorageDispatchTypes, TabSessionStorageReAuthDispatchTypes } from "./TabSessionStorage";

export enum ApplicationTitles {
  PRONET_CONNECT = "ProNet Connect",
  MY_ACCOUNT = "My Account",
  ADMIN = "Admin Portal",
  PROVIDER_LISTING = "Provider Materials",
  REFERRAL_HISTORY = "Referral History",
  LOGOUT = "Logout",
  HOME = "Home",
  TRAINING = "Training",
  CREATE_PRIOR_AUTH = "Create Prior-Auth",
  PROVIDER_FINDER = "Provider Finder",
  FAQS = "FAQs",
  UPLOADS = "Uploads",
  AUTH_ARCHIVE = "Auth Archive",
  REFERRAL_MANAGEMENT = "Referral Mgmt",
  OASIS_UPLOAD = "Oasis Upload",
  CHECK_ELIGIBILITY = "Check Eligibility",
  PROVIDER_LIST = "Provider Listing",
  SCORECARD = "Scorecard",
  PATIENT_LIST = "Patient List",
  CREATE_REAUTH = "Create ReAuth",
  AGENCY_ACCESS = "Agency Access",
  DOCUMENT_DOWNLOAD = "Document Download",
  MEMBER_INFO = "Member Info",
  SSO_HPS = "Claims Status",
  HPP_SSO = "Health Plan Portal",
}

export enum UserRole {
  TANGO_ADMIN = "Tango Admin",
  PROVIDER_ADMIN = "Provider Admin",
  PROVIDER_USER = "Provider User",
  HEALTHPLAN_USER = "Health Plan User",
}

export const ROLE_ID_TANGO_ADMIN = 0;
export const ROLE_ID_PROVIDER_ADMIN = 1;
export const ROLE_ID_PROVIDER_USER = 2;

export const ROLE_IDS_ALL = [
  ROLE_ID_TANGO_ADMIN,
  ROLE_ID_PROVIDER_ADMIN,
  ROLE_ID_PROVIDER_USER,
];

export const ROLE_IDS_PROVIDER_ADMIN_AND_ABOVE = [
  ROLE_ID_TANGO_ADMIN,
  ROLE_ID_PROVIDER_ADMIN,
];

export const ROLE_IDS_TANGO_ADMIN_ONLY = [ROLE_ID_TANGO_ADMIN];

export type MenuItemType = {
  path: string;
  title: string;
  icon?: any;
  subMenu? : SubMenuType[]
};

export type LeftMenuOptionType = MenuItemType & {
  role: UserRole[];
  featureId: FeatureId;
};

export interface MenuType {
  path: string;
  title: string;
  role: string[];
}

export interface SubMenuType {
  link: string;
  title: string;
}

export const roleAccess1 = [
  UserRole.TANGO_ADMIN,
  UserRole.PROVIDER_ADMIN,
  UserRole.PROVIDER_USER,
];
export const roleAccess2 = [UserRole.TANGO_ADMIN, UserRole.PROVIDER_ADMIN];

export const roleAccess3 = [UserRole.TANGO_ADMIN];

export const HeaderRightMenu: MenuType[] = [
  {
    path: ApplicationRoute.MY_ACCOUNT,
    title: ApplicationTitles.MY_ACCOUNT,
    role: roleAccess1,
  },
  {
    path: ApplicationRoute.ADMIN,
    title: ApplicationTitles.ADMIN,
    role: roleAccess2,
  },
  {
    path: ApplicationRoute.PROVIDER_LIST,
    title: ApplicationTitles.PROVIDER_LIST,
    role: roleAccess3,
  },
  {
    path: ApplicationRoute.LOGOUT,
    title: ApplicationTitles.LOGOUT,
    role: roleAccess1,
  },
];

export enum FeatureId {
  CHAT = 1,
  SCORECARD = 2,
  COMPARE_NPI = 3,
  CREATE_PRIOR_AUTH = 4,
  SSO_HPS = 5,
  HPP_SSO = 10,
  CHECK_ELIGIBILITY = 6,
  HOME = 7,
  PROVIDER_FINDER = 8,
  PROVIDER_LISTING = 16,
  UPLOADS = 11,
  REFERRAL_MANAGEMENT = 12,
  OASIS_UPLOAD = 13,
  NOMNC = 14,
  TRAINING = 15,
  FAQS = 17,
}

export const LeftMenuOption: LeftMenuOptionType[] = [
  {
    path: ApplicationRoute.HOME,
    title: ApplicationTitles.HOME,
    icon: FaHouseChimneyIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.HOME
  },
  {
    path: ApplicationRoute.TRAINING,
    title: ApplicationTitles.TRAINING,
    icon: FaCertificateIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.TRAINING
  },
  {
    path: ApplicationRoute.CHECK_ELIGIBILITY,
    title: ApplicationTitles.CHECK_ELIGIBILITY,
    icon: FaCircleCheckIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.CHECK_ELIGIBILITY
  },
  {
    path: ApplicationRoute.MEMBER_INFO,
    title: ApplicationTitles.CREATE_PRIOR_AUTH,
    icon: FaLockIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.CREATE_PRIOR_AUTH
  },
  {
    path: ApplicationRoute.PROVIDER_FINDER,
    title: ApplicationTitles.PROVIDER_FINDER,
    icon: FaMagnifyingGlassLocationIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.PROVIDER_FINDER
  },
  {
    path: ApplicationRoute.PROVIDER_LISTING,
    title: ApplicationTitles.PROVIDER_LISTING,
    icon: FaUsersIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.PROVIDER_LISTING
  },
  {
    path: ApplicationRoute.FAQS,
    title: ApplicationTitles.FAQS,
    icon: FaCircleQuestionIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.FAQS
  },
  {
    path: ApplicationRoute.SCORECARD,
    title: ApplicationTitles.SCORECARD,
    icon: FaTableListIcon,
    role: roleAccess2, //tbd
    featureId: FeatureId.SCORECARD
  },
  {
    path: ApplicationRoute.UPLOADS,
    title: ApplicationTitles.UPLOADS,
    icon: FaFileArrowUpIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.UPLOADS,
    subMenu: [
      {
        link: DownloadUrl.OASIS_UPLOAD,
        title: ApplicationTitles.OASIS_UPLOAD,
      }
    ],
  },
  {
    path: ApplicationRoute.REFERRAL_MANAGEMENT,
    title: ApplicationTitles.REFERRAL_MANAGEMENT,
    icon: FaBusinessTimeIcon,
    role: roleAccess1, //tbd
    featureId: FeatureId.REFERRAL_MANAGEMENT
  },
    {
    path: ApplicationRoute.SSO_HPS,
    title: ApplicationTitles.SSO_HPS,
    icon: FaCalculatorIcon,
    role: roleAccess1,
    featureId: FeatureId.SSO_HPS
  },
      {
    path: ApplicationRoute.HPP_SSO,
    title: ApplicationTitles.HPP_SSO,
    icon: FaHpsIcon,
    role: roleAccess1,
    featureId: FeatureId.HPP_SSO
  },
];

export const AuthHistoryHeaderLabel = [
  { label: "Request Date", style: { cell: HeadCell50 } },
  { label: "Status", style: { cell: HeadCell30 } },
  { label: "Effective Dates", style: { cell: HeadCell70 } },
  { label: "Uploaded documents (portal only)", style: { cell: HeadCell90 } },
  { label: "SN", style: { cell: HeadCell10 } },
  { label: "PT", style: { cell: HeadCell10 } },
  { label: "OT", style: { cell: HeadCell10 } },
  { label: "ST", style: { cell: HeadCell10 } },
  { label: "MSW", style: { cell: HeadCell20 } },
  { label: "HHA", style: { cell: HeadCell20 } },
];

export const DocumentReviewHeaderLabel = [
  { label: "File Name", style: { cell: HeadCell90 } },
  { label: "File Size", style: { cell: HeadCell50 } },
  { label: "Date/Time of Request", style: { cell: HeadCell90 } },
];

export enum GetReferralListActionDispatchTypes {
  GET_REFERRAL_LIST_SUCCESS = "GET_REFERRAL_LIST_SUCCESS",
  GET_REFERRAL_LIST_ERROR = "GET_REFERRAL_LIST_ERROR",
  GET_REFERRAL_LIST_INVOKE = "GET_REFERRAL_LIST_INVOKE",
  GET_REFERRAL_LIST_RESET = "GET_REFERRAL_LIST_RESET",
}

export const defaultReferralPayload: ReferralSearchPayload = {
  providerId: 0,
  pageNo: 1,
  pageSize: PER_PAGE,
  searchTerm: ""
};

export enum GetReferralSearchListActionDispatchTypes {
  GET_REFERRAL_SEARCH_LIST_SUCCESS = "GET_REFERRAL_SEARCH_LIST_SUCCESS",
  GET_REFERRAL_SEARCH_LIST_ERROR = "GET_REFERRAL_SEARCH_LIST_ERROR",
  GET_REFERRAL_SEARCH_LIST_INVOKE = "GET_REFERRAL_SEARCH_LIST_INVOKE",
  GET_REFERRAL_SEARCH_LIST_RESET = "GET_REFERRAL_SEARCH_LIST_RESET",
}

export enum GetReferralAuthHistoryActionDispatchTypes {
  GET_REFERRAL_AUTH_HISTORY_SUCCESS = "GET_REFERRAL_AUTH_HISTORY_SUCCESS",
  GET_REFERRAL_AUTH_HISTORY_ERROR = "GET_REFERRAL_AUTH_HISTORY_ERROR",
  GET_REFERRAL_AUTH_HISTORY_INVOKE = "GET_REFERRAL_AUTH_HISTORY_INVOKE",
  GET_REFERRAL_AUTH_HISTORY_RESET = "GET_REFERRAL_AUTH_HISTORY_RESET",
}

export const defaultListData = {
  label: "",
  value: 0,
};

export enum PostNtuPatientActionDispatchTypes {
  POST_NTU_PATIENT_SUCCESS = "POST_NTU_PATIENT_SUCCESS",
  POST_NTU_PATIENT_ERROR = "POST_NTU_PATIENT_ERROR",
  POST_NTU_PATIENT_INVOKE = "POST_NTU_PATIENT_INVOKE",
  POST_NTU_PATIENT_RESET = "POST_NTU_PATIENT_RESET",
}

export enum NtuReasonMasterActionDispatchTypes {
  GET_NTU_REASON_INVOKE = "GET_NTU_REASON_INVOKE",
  GET_NTU_REASON_SUCCESS = "GET_NTU_REASON_SUCCESS",
  GET_NTU_REASON_ERROR = "GET_NTU_REASON_ERROR",
}

export interface Header {
  label: string;
  style: any;
}

export const PatientListHeaderLabel = [
  { label: "Patient Name", style: { cell: HeadCell50 } },
  { label: "DOB", style: { cell: HeadCell30 } },
  { label: "Auth#", style: { cell: HeadCell70 } },
  { label: "Auth Period", style: { cell: HeadCell70 } },
  { label: "SN", style: { cell: HeadCell10 } },
  { label: "PT", style: { cell: HeadCell10 } },
  { label: "OT", style: { cell: HeadCell10 } },
  { label: "ST", style: { cell: HeadCell10 } },
  { label: "MSW", style: { cell: HeadCell20 } },
  { label: "HHA", style: { cell: HeadCell20 } },
  { label: "Total", style: { cell: HeadCell20 } },
];

export const ProviderListing = [
  { label: "Provider", style: { cell: HeadCell30 } },
  { label: "NPI #", style: { cell: HeadCell70 } },
  { label: "State", style: { cell: HeadCell70 } },
  { label: "Status", style: { cell: HeadCell10 } },
  { label: "Credentialed", style: { cell: HeadCell70 } },
  { label: "Joined Date", style: { cell: HeadCell70 } },
  { label: "Expiration Data", style: { cell: HeadCell70 } },
];

export const SESSION_TIMEOUT = 13 * 60 * 1000;
export const IDLE_TIMEOUT = 2 * 60 * 1000;

export const allowedStates = ["CO", "NM", "PA"];

export const ResetAuthReAuthTypes = [
  MemberInfoDataActionDispatchTypes.MEMBER_INFO_DATA_RESET,
  EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_RESET,
  PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_RESET,
  PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_RESET,
  InformationActionDispatchTypes.INFORMATION_RESET,
  CreatePatientActionDispatchTypes.CREATE_PATIENT_RESET,
  TabSessionStorageDispatchTypes.SET_TAB_DATA_RESET,
  MasterPayerActionDispatchTypes.MASTER_PAYER_RESET,
  PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_RESET,
  ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_RESET,
  IcdCodeActionDispatchTypes.ICD_CODE_RESET,
  IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET,
  MasterDisciplineActionDispatchTypes.MASTER_DISCIPLINE_INVOKE,
  SlotsDispatchTypes.SLOTS_RESET,
  TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_RESET,
  PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_RESET,
];

export const DocumentDEHeaderLabel = [
  { label: "Document Name", style: { cell: HeadCell90 } },
  { label: "Date/Time", style: { cell: HeadCell90 } },
];

export enum PostAuthNotificationsActionDispatchTypes {
  POST_AUTH_NOTIFICATIONS_INVOKE = "POST_AUTH_NOTIFICATIONS_INVOKE",
  POST_AUTH_NOTIFICATIONS_SUCCESS = "POST_AUTH_NOTIFICATIONS_SUCCESS",
  POST_AUTH_NOTIFICATIONS_ERROR = "POST_AUTH_NOTIFICATIONS_ERROR",
  POST_AUTH_NOTIFICATIONS_RESET = "POST_AUTH_NOTIFICATIONS_RESET",
}

export enum AuthNotificationsDownloadActionDispatchTypes {
  GET_AUTH_NOTIFICATIONS_DOWNLOAD_SUCCESS = "GET_AUTH_NOTIFICATIONS_DOWNLOAD_SUCCESS",
  GET_AUTH_NOTIFICATIONS_DOWNLOAD_INVOKE = "GET_AUTH_NOTIFICATIONS_DOWNLOAD_INVOKE",
  GET_AUTH_NOTIFICATIONS_DOWNLOAD_ERROR = "GET_AUTH_NOTIFICATIONS_DOWNLOAD_ERROR",
}